import React from 'react';
import s from './ContentBlock.module.scss';

const ContentBlock = ({background, children}) => {
    const styleBackground = background ? {backgroundColor: `${background}`} : {backgroundColor: 'none'};
    return (
        <div className={s.cover} style={styleBackground}>
            <div className={s.wrap}>
                {children}
            </div>
        </div>
    );
}

export default ContentBlock;